var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Dependencies } from '~/core/decorator';
import { PageService } from '~/utils/page.service';
import { UserService } from '~/services/management-service/user.service';
import { RoleService } from '~/services/management-service/role.service';
import { Emit, Prop } from 'vue-property-decorator';
var BatchAllotRole = /** @class */ (function (_super) {
    __extends(BatchAllotRole, _super);
    function BatchAllotRole() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.model = {
            roleName: '',
            companyCode: _this.companyCode,
            roleStatus: 'ENABLED',
        };
        _this.selectionRow = [];
        _this.dataSet = [];
        return _this;
    }
    BatchAllotRole.prototype.refreshList = function () { };
    BatchAllotRole.prototype.close = function () { };
    BatchAllotRole.prototype.refresh = function () {
        this.model.roleName = '';
        this.refreshData();
        this.selectionRow = [];
    };
    BatchAllotRole.prototype.confirm = function () {
        var _this = this;
        var roleIds = this.selectionRow.map(function (row) { return row.id; });
        var userIds = this.userList.map(function (v) { return v.id; });
        this.userService.batchAllotRole({ roleIds: roleIds, userIds: userIds }).subscribe(function (data) {
            _this.$message.success('分配成功');
            _this.close();
            _this.refreshList();
        });
    };
    BatchAllotRole.prototype.refreshData = function () {
        var _this = this;
        this.roleService.getAllRoles(this.model, this.pageService).subscribe(function (data) {
            _this.dataSet = data;
        });
    };
    __decorate([
        Dependencies(PageService)
    ], BatchAllotRole.prototype, "pageService", void 0);
    __decorate([
        Dependencies(UserService)
    ], BatchAllotRole.prototype, "userService", void 0);
    __decorate([
        Dependencies(RoleService)
    ], BatchAllotRole.prototype, "roleService", void 0);
    __decorate([
        Prop()
    ], BatchAllotRole.prototype, "userList", void 0);
    __decorate([
        Prop()
    ], BatchAllotRole.prototype, "companyCode", void 0);
    __decorate([
        Emit('refreshList')
    ], BatchAllotRole.prototype, "refreshList", null);
    __decorate([
        Emit('close')
    ], BatchAllotRole.prototype, "close", null);
    BatchAllotRole = __decorate([
        Component({
            components: {},
        })
    ], BatchAllotRole);
    return BatchAllotRole;
}(Vue));
export default BatchAllotRole;
